import { render, staticRenderFns } from "./SinglePropertyChangeRequest.vue?vue&type=template&id=6a5f859e"
import script from "./SinglePropertyChangeRequest.vue?vue&type=script&lang=ts"
export * from "./SinglePropertyChangeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports